import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import { getLocalisedMessage } from '../../utilities/Errors/index'
import that from '../../utilities/translationHelper'
import showAppMessage from './utilities/showAppMessage'

const genericLoginError = that.context.translate('An error occurred trying to login.')
const accountExistsError = that.context.translate('Your Facebook email is already associated with an account. Unfortunately this means you must login using your email instead.')
const invalidActionCodeError = that.context.translate('Your session has expired.')

const getLoginErrorMessage = (error) => {
	if (error.code === 'auth/account-exists-with-different-credential') {
		return accountExistsError
	}
	if (error.code === 'auth/invalid-action-code') {
		return invalidActionCodeError
	}
	return getLocalisedMessage(error, genericLoginError)
}

export default createReducer({}, {
	[at.auth.complete.TRIGGER]: (state, action) => {
		const newUser = action.payload.user
		if (state.user.suggestedUserProfile && state.user.suggestedUserProfile.uid === newUser.uid) {
			newUser.userProfile = state.user.suggestedUserProfile
		}
		return ({
			...state,
			user: newUser
		})
	},
	[at.auth.reset.TRIGGER]: (state) => {
		const newState = Object.assign({}, state)
		delete newState.authEmailLoginFail
		delete newState.authEmailLoginSuccess
		delete newState.authEmailLoginError
		delete newState.authFacebookLoginSuccess
		delete newState.authInstagramLoginSuccess
		return {
			...newState
		}
	},
	[at.authFacebookPopup.login.SUCCESS]: state => ({
		...state,
		authFacebookLoginSuccess: true
	}),
	[at.authFacebookPopup.login.FAIL]: (state, action) => ({
		...state,
		...showAppMessage(getLoginErrorMessage(action.payload.error))
	}),
	[at.authInstagramPopup.login.SUCCESS]: state => ({
		...state,
		authInstagramLoginSuccess: true
	}),
	[at.authInstagramPopup.login.FAIL]: (state, action) => ({
		...state,
		...showAppMessage(getLoginErrorMessage(action.payload.error))
	}),
	[at.authEmail.login.TRIGGER]: (state) => {
		const newState = Object.assign({}, state)
		delete newState.authEmailLoginFail
		delete newState.authEmailLoginSuccess
		delete newState.authEmailLoginError
		delete newState.authEmailLoginAlreadyComplete
		delete newState.authEmailLoginCompleteEmailAddressRequired
		delete newState.authEmailLoginCompleteFail
		delete newState.authEmailLoginCompleteSuccess
		delete newState.authEmailLoginCompleteError
		return {
			...newState
		}
	},
	[at.authEmail.login.SUCCESS]: state => ({
		...state,
		authEmailLoginSuccess: true
	}),
	[at.authEmail.login.FAIL]: (state, action) => ({
		...state,
		authEmailLoginFail: true,
		authEmailLoginError: getLoginErrorMessage(action.payload.error)
	}),
	[at.authEmailSent]: (state, action) => ({
		...state,
		emailSent: action.payload.emailSent
	}),
	[at.authEmail.loginComplete.TRIGGER]: (state) => {
		const newState = Object.assign({}, state)
		delete newState.authEmailLoginAlreadyComplete
		delete newState.authEmailLoginCompleteEmailAddressRequired
		delete newState.authEmailLoginCompleteFail
		delete newState.authEmailLoginCompleteSuccess
		delete newState.authEmailLoginCompleteError
		return {
			...newState
		}
	},
	[at.authEmail.emailRequired.TRIGGER]: state => ({
		...state,
		authEmailLoginCompleteEmailAddressRequired: true
	}),
	[at.authEmail.loginAlreadyComplete.TRIGGER]: state => ({
		...state,
		authEmailLoginAlreadyComplete: true
	}),
	[at.authEmail.loginComplete.SUCCESS]: state => ({
		...state,
		authEmailLoginCompleteSuccess: true
	}),
	[at.authEmail.loginComplete.FAIL]: (state, action) => (!state.authEmailLoginCompleteEmailAddressRequired && !state.authEmailLoginAlreadyComplete ? {
		...state,
		authEmailLoginCompleteFail: true,
		authEmailLoginCompleteError: getLoginErrorMessage(action.payload.error)
	} : state),

	[at.authFacebookRedirect.loginComplete.TRIGGER]: (state) => {
		const newState = Object.assign({}, state)
		delete newState.facebookLoginCompleteFail
		delete newState.facebookLoginCompleteSuccess
		delete newState.facebookLoginCompleteError
		return {
			...newState
		}
	},
	[at.authFacebookRedirect.loginComplete.SUCCESS]: state => ({
		...state,
		facebookLoginCompleteSuccess: true
	}),
	[at.authFacebookRedirect.loginComplete.FAIL]: (state, action) => ({
		...state,
		facebookLoginCompleteFail: true,
		facebookLoginCompleteError: getLoginErrorMessage(action.payload.error),
		facebookLoginCompleteErrorEmailAccountExists: action.payload.error.code === 'auth/account-exists-with-different-credential' ? action.payload.error.email : ''
	}),

	[at.authInstagramRedirect.loginComplete.TRIGGER]: (state) => {
		const newState = Object.assign({}, state)
		delete newState.instagramLoginCompleteFail
		delete newState.instagramLoginCompleteSuccess
		delete newState.instagramLoginCompleteError
		return {
			...newState
		}
	},
	[at.authInstagramRedirect.loginComplete.SUCCESS]: state => ({
		...state,
		instagramLoginCompleteSuccess: true
	}),
	[at.authInstagramRedirect.loginComplete.FAIL]: (state, action) => ({
		...state,
		instagramLoginCompleteFail: true,
		instagramLoginCompleteError: getLoginErrorMessage(action.payload.error)
	})

})



// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js